export interface AssetDetailParams {
	assetId: string;
	assetType: string;
	layerId?: string;
}

export const parseAssetDetailParams = (
	id: string,
	layerId?: string,
	assetId?: string,
	assetType?: string,
): AssetDetailParams => {
	if (assetId && assetType) {
		return { assetId, assetType, layerId };
	}

	const [assetTypeFromId, assetIdFromId] = id.split('#');
	return {
		assetId: assetIdFromId,
		assetType: assetTypeFromId,
		layerId,
	};
};
